module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "ePub-SC-B1"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("Everyone should have a friend like Fran McClain. Not only does she lend me prized cookbooks and handwritten recipes, but she also hosted a German Oktoberfest for me in July so I could sample sauerbraten and spaetzle. And to Greg, my son, who truly gets what it’s like to be a writer—and lets me know he’s proud of me. Have I told my friends in the Purple Gang and Sweet T’s how much I appreciate you welcoming me back into the fold after lengthy absences while I’ve been in the “basement” writing? If not, forgive me. I treasure your friendships. No less appreciated is my husband, Bob, who never complains about egg sandwiches for dinner. My acknowledgments wouldn’t be complete without a shout-out to the wonderful readers who love nothing more than to curl up with a cozy. May that addiction never end.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0